import { URLS } from '../../env/urls';
import { sendServerRequest } from '../../server/request';
import {
  CreateTelegramBotRequest,
  UpdateTelegramBotRequest,
  TelegramBotsListResponse,
  TelegramBot,
  V8Login,
} from '../../types/admin';

// API dedicada dos bots do Telegram (multi-bot). Ao contrário do Evolution, cada bot registra
// o próprio webhook no Telegram — o backend faz isso sozinho no create (getMe + setWebhook).
export const telegramBotsApi = {
  async create(data: CreateTelegramBotRequest): Promise<TelegramBot> {
    const result = await sendServerRequest('POST', URLS.admin.accounts.telegram.create, data);
    return result.data.data;
  },

  async list(page: number = 0, limit: number = 20): Promise<TelegramBotsListResponse> {
    const url = `${URLS.admin.accounts.telegram.list}?page=${page}&limit=${limit}`;
    const result = await sendServerRequest('GET', url);
    // O backend responde { bots, total, page, limit, pages }.
    return result.data.data;
  },

  async getById(id: number): Promise<TelegramBot> {
    const url = URLS.admin.accounts.telegram.get(id);
    const result = await sendServerRequest('GET', url);
    return result.data.data.bot;
  },

  async update(id: number, data: UpdateTelegramBotRequest): Promise<TelegramBot> {
    const url = URLS.admin.accounts.telegram.update(id);
    const result = await sendServerRequest('PUT', url, data);
    return result.data.data;
  },

  async delete(id: number): Promise<void> {
    const url = URLS.admin.accounts.telegram.delete(id);
    await sendServerRequest('DELETE', url);
  },

  async toggle(id: number): Promise<{ id: number; is_active: boolean }> {
    const url = URLS.admin.accounts.telegram.toggle(id);
    const result = await sendServerRequest('PATCH', url);
    return result.data.data;
  },

  // Testa o bot enviando uma mensagem para um chat_id (o usuário precisa ter dado /start antes —
  // o bot não pode iniciar conversa).
  async test(id: number, chatId: string): Promise<{ sent: boolean; to: string; message_id?: string }> {
    const url = URLS.admin.accounts.telegram.test(id);
    const result = await sendServerRequest('POST', url, { chat_id: chatId });
    return result.data.data;
  },

  // Lista os V8 logins disponíveis para atrelar ao bot (rota dedicada do admin).
  async listV8Logins(): Promise<V8Login[]> {
    const result = await sendServerRequest('GET', URLS.admin.accounts.v8.list);
    return result.data.data.v8s ?? [];
  },
};
